var map = {
	"./acc0.png": 8333,
	"./acc1.png": 3146,
	"./acc10.png": 8351,
	"./acc11.png": 1219,
	"./acc12.png": 1049,
	"./acc13.png": 7505,
	"./acc14.png": 2922,
	"./acc15.png": 4793,
	"./acc16.png": 6262,
	"./acc17.png": 1110,
	"./acc18.png": 7631,
	"./acc19.png": 6640,
	"./acc2.png": 5502,
	"./acc20.png": 3189,
	"./acc21.png": 3944,
	"./acc22.png": 1196,
	"./acc23.png": 4043,
	"./acc24.png": 9189,
	"./acc25.png": 5385,
	"./acc26.png": 9013,
	"./acc27.png": 4086,
	"./acc28.png": 6738,
	"./acc29.png": 6525,
	"./acc3.png": 3805,
	"./acc30.png": 3078,
	"./acc31.png": 3312,
	"./acc32.png": 8168,
	"./acc33.png": 9505,
	"./acc34.png": 2597,
	"./acc35.png": 1036,
	"./acc36.png": 1111,
	"./acc4.png": 8253,
	"./acc5.png": 89,
	"./acc6.png": 8558,
	"./acc7.png": 3403,
	"./acc8.png": 9756,
	"./acc9.png": 3251,
	"./backbutton.png": 3334,
	"./backhover.png": 6431,
	"./bg.png": 7362,
	"./bg0.png": 8363,
	"./bg1.png": 5367,
	"./bg10.png": 1328,
	"./bg11.png": 5386,
	"./bg12.png": 6085,
	"./bg13.png": 2241,
	"./bg14.png": 6718,
	"./bg15.png": 6862,
	"./bg16.png": 5180,
	"./bg17.png": 8606,
	"./bg18.png": 3623,
	"./bg19.png": 4993,
	"./bg2.png": 5019,
	"./bg20.png": 52,
	"./bg21.png": 3769,
	"./bg22.png": 1927,
	"./bg23.png": 4645,
	"./bg24.png": 9397,
	"./bg25.png": 329,
	"./bg26.png": 1853,
	"./bg27.png": 1585,
	"./bg28.png": 4673,
	"./bg29.png": 9116,
	"./bg3.png": 9785,
	"./bg30.png": 771,
	"./bg4.png": 8262,
	"./bg5.png": 8043,
	"./bg6.png": 4266,
	"./bg7.png": 2297,
	"./bg8.png": 6378,
	"./bg9.png": 6576,
	"./bigbg.png": 9748,
	"./bigbgbottom.png": 3026,
	"./bigbgmiddle.png": 2161,
	"./bigbgtop.png": 2044,
	"./body0.png": 4802,
	"./body1.png": 2110,
	"./body10.png": 406,
	"./body11.png": 6821,
	"./body12.png": 2105,
	"./body13.png": 1545,
	"./body14.png": 4637,
	"./body15.png": 6939,
	"./body16.png": 299,
	"./body17.png": 4120,
	"./body18.png": 2719,
	"./body19.png": 1056,
	"./body2.png": 3465,
	"./body20.png": 1337,
	"./body21.png": 7304,
	"./body22.png": 8131,
	"./body23.png": 6183,
	"./body24.png": 4654,
	"./body3.png": 9060,
	"./body4.png": 9421,
	"./body5.png": 429,
	"./body6.png": 8137,
	"./body7.png": 9471,
	"./body8.png": 6972,
	"./body9.png": 3531,
	"./border.png": 4543,
	"./border_large.png": 1850,
	"./border_small.png": 9005,
	"./bordersmall.png": 1888,
	"./color0.png": 7722,
	"./color1.png": 1117,
	"./color10.png": 4136,
	"./color11.png": 5063,
	"./color12.png": 5007,
	"./color13.png": 4449,
	"./color14.png": 4387,
	"./color15.png": 9023,
	"./color16.png": 4312,
	"./color17.png": 3066,
	"./color18.png": 6542,
	"./color19.png": 4895,
	"./color2.png": 2991,
	"./color20.png": 9296,
	"./color21.png": 2973,
	"./color22.png": 1309,
	"./color3.png": 2569,
	"./color4.png": 9908,
	"./color5.png": 3326,
	"./color6.png": 8402,
	"./color7.png": 6684,
	"./color8.png": 4297,
	"./color9.png": 9168,
	"./colorIcon.png": 9552,
	"./face0.png": 2860,
	"./face1.png": 1914,
	"./face10.png": 767,
	"./face11.png": 5589,
	"./face12.png": 8504,
	"./face13.png": 3382,
	"./face14.png": 863,
	"./face15.png": 9171,
	"./face16.png": 9303,
	"./face17.png": 1122,
	"./face18.png": 3601,
	"./face19.png": 9221,
	"./face2.png": 4646,
	"./face20.png": 4403,
	"./face21.png": 9202,
	"./face22.png": 1504,
	"./face23.png": 4469,
	"./face24.png": 3692,
	"./face25.png": 262,
	"./face26.png": 4778,
	"./face27.png": 4062,
	"./face28.png": 8485,
	"./face29.png": 5483,
	"./face3.png": 3,
	"./face30.png": 2587,
	"./face31.png": 9105,
	"./face32.png": 5205,
	"./face33.png": 4018,
	"./face34.png": 421,
	"./face35.png": 903,
	"./face36.png": 6873,
	"./face37.png": 5309,
	"./face38.png": 5046,
	"./face39.png": 3586,
	"./face4.png": 109,
	"./face40.png": 5667,
	"./face41.png": 4144,
	"./face42.png": 7408,
	"./face43.png": 5980,
	"./face44.png": 7038,
	"./face45.png": 6973,
	"./face5.png": 2663,
	"./face6.png": 1915,
	"./face7.png": 7326,
	"./face8.png": 2486,
	"./face9.png": 3055,
	"./frogbase.png": 6348,
	"./ghostFrog.png": 7500,
	"./hat0.png": 3841,
	"./hat1.png": 7414,
	"./hat10.png": 288,
	"./hat11.png": 9725,
	"./hat12.png": 891,
	"./hat13.png": 535,
	"./hat14.png": 1199,
	"./hat15.png": 2034,
	"./hat16.png": 2106,
	"./hat17.png": 278,
	"./hat18.png": 8110,
	"./hat19.png": 4359,
	"./hat2.png": 4406,
	"./hat20.png": 5060,
	"./hat21.png": 7406,
	"./hat22.png": 7062,
	"./hat23.png": 3703,
	"./hat24.png": 8840,
	"./hat25.png": 1990,
	"./hat26.png": 7798,
	"./hat27.png": 3203,
	"./hat28.png": 8661,
	"./hat29.png": 6849,
	"./hat3.png": 6404,
	"./hat30.png": 4742,
	"./hat31.png": 1611,
	"./hat32.png": 2728,
	"./hat33.png": 5043,
	"./hat34.png": 3378,
	"./hat35.png": 510,
	"./hat36.png": 6891,
	"./hat37.png": 8747,
	"./hat38.png": 8789,
	"./hat39.png": 9498,
	"./hat4.png": 1937,
	"./hat40.png": 1017,
	"./hat41.png": 1603,
	"./hat42.png": 1437,
	"./hat43.png": 4279,
	"./hat44.png": 3252,
	"./hat45.png": 6705,
	"./hat46.png": 4678,
	"./hat47.png": 3603,
	"./hat48.png": 6657,
	"./hat49.png": 3654,
	"./hat5.png": 9074,
	"./hat50.png": 8306,
	"./hat51.png": 4333,
	"./hat52.png": 468,
	"./hat53.png": 8540,
	"./hat54.png": 3791,
	"./hat55.png": 6094,
	"./hat56.png": 6223,
	"./hat57.png": 84,
	"./hat58.png": 1741,
	"./hat59.png": 7554,
	"./hat6.png": 1898,
	"./hat60.png": 6510,
	"./hat61.png": 7883,
	"./hat62.png": 8524,
	"./hat63.png": 6667,
	"./hat64.png": 2602,
	"./hat65.png": 3753,
	"./hat66.png": 1137,
	"./hat67.png": 909,
	"./hat68.png": 5055,
	"./hat7.png": 2652,
	"./hat8.png": 7677,
	"./hat9.png": 1805,
	"./newbigbgbottom.png": 8722,
	"./newbigbgmiddle.png": 4665,
	"./newbigbgtop.png": 83,
	"./overlay.png": 7692,
	"./resetbutton.png": 6991,
	"./resethover.png": 6349,
	"./savebutton.png": 9922,
	"./savehover.png": 8894,
	"./transparent.png": 3451,
	"./ui.png": 2709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1600;